import { Text } from "@mantine/core";


function Countdown(props) {

  const moreThanXDaysAway = (x) => {

    var currentDateTime = new Date()

    if((props.deliveryDate - currentDateTime) / (1000*60*60*24) > x) {
      return true
    }
    else {
      return false
    }

  } 
  const arrivesByText = " - delivered by " + (moreThanXDaysAway(5) ? props.deliveryDate.toLocaleDateString('en-US', {weekday: 'long', month: 'long', day: 'numeric'}) : props.deliveryDate.toLocaleDateString('en-US', {weekday: 'long', month: 'long', day: 'numeric'}))
  
  const secondsToDhms = (seconds) => {
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600*24));
    var h = Math.floor(seconds % (3600*24) / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);
    
    var dDisplay = d > 0 ? d + (d == 1 ? " day, " : " days, ") : "";
    var hDisplay = h > 0 || dDisplay !== "" ? h + (h == 1 ? " hour, " : " hours, ") : "";
    var mDisplay = m > 0 || dDisplay !== "" || hDisplay !== "" ? m + (m == 1 ? " minute " : " minutes ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    var textToReturn = dDisplay + hDisplay + mDisplay
    if(textToReturn.endsWith(" ")) {textToReturn = textToReturn.substring(0,textToReturn.length - 1) + "."}
    return textToReturn  //+ sDisplay;
    }
  return (<><span style={{}}>{arrivesByText}</span>{". Order within "}<span style={{color: "#0aab4e", fontWeight: "500"}}>{secondsToDhms(props.secondsToCutoff)}</span></>)
  
}

export default Countdown;
